import { Directive, HostListener, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { NgControl } from "@angular/forms";
import { PersianService } from "projects/sepidz-web-framework/src/lib/services/persian.service";

@Directive({
  selector: "input[SsgMask]",
})
export class SsgMaskDirective implements OnInit {
  @Input("SsgMask") _SsgMask: string;
  @Output() retornoKzMask = new EventEmitter();
  constructor(public model: NgControl, private persianService: PersianService) {}
  ngOnInit(): void {}

  @HostListener("keyup", ["$event"])
  onKeyup($event: any) {
    if ($event.keyCode === 8 || $event.keyCode === 37 || $event.keyCode === 39 || !this._SsgMask || this._SsgMask.length <= 0) {
      return;
    }
    if ($event.keyCode === 65) $event.target.value = "";

    var PrevValue = this.persianService.toEnglishNumberString($event.target.value.toString().replace(/\_/g, "").replace(/\:/g, ""));
    if (PrevValue === "NaN") PrevValue = "";
    if (isNaN($event.target.value)) valor = "";

    // codigo
    var valor = PrevValue.replace(/D\0/g, "");

    var pad = this._SsgMask.replace(/\D/g, "").replace(/0/g, "_");
    var valorMask = valor + pad.substring(0, pad.length - valor.length);

    var valorMaskPos = 0;
    valor = "";
    for (var i = 0; i < this._SsgMask.length; i++) {
      if (isNaN(parseInt(this._SsgMask.charAt(i)))) {
        valor += this._SsgMask.charAt(i);
      } else {
        valor += valorMask[valorMaskPos++];
      }
    }
    $event.target.value = valor;
    this.retornoKzMask.emit($event.target.value);
  }

  @HostListener("blur", ["$event"])
  onBlur($event: any) {
    // codigo
    if (!this._SsgMask || $event.target.value.length === this._SsgMask.length || this._SsgMask.length <= 0) {
      return;
    }
    $event.target.value = "";
    this.retornoKzMask.emit($event.target.value);
  }
}
